import { gaTracking, getCurrentPageLocation, normalizeString } from "../../lib/ga";

/**
 * Tracks file download events
 * @param fileName - Name of the downloaded file
 * @param extention - File extension (e.g., "pdf", "docx")
 * @param insurance - Optional insurance context
 * @see /GAExamples/file_download.js
 */
export const fileDownloadTracker = (
  fileName: string,
  extention: string,
  insurance: string,
): void => {
  gaTracking({
    event: "file_download",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      file_name: normalizeString(fileName) ?? "",
      file_extension: normalizeString(extention) ?? "",
      insurance: normalizeString(insurance),
    },
  });
};
